/**
 * Incident report charting entry DTOs
 * Extracted from src/services/patientmr/charting.service.ts
 */

import { BaseEntryData } from './chart-entry.dto';
import type { EntryVisibility } from './general-note.dto';

/**
 * Incident report data structure
 */
export interface IncidentData extends BaseEntryData {
  incidentType?: string;
  description: string;
  witnesses?: string[];
  injuryDetails?: string;
  actionsTaken?: string;
  reportedTo?: string;
  /** Kept for compatibility; true reads and writes as visibility INTERNAL (Phase 18 M6) */
  internalOnly?: boolean;
  visibility?: EntryVisibility;
  /** CHT-08 */
  severity?: IncidentSeverity;
}

export const INCIDENT_SEVERITIES = ['LOW', 'MODERATE', 'HIGH', 'CRITICAL'] as const;
export type IncidentSeverity = typeof INCIDENT_SEVERITIES[number];
